
import { butter } from "../plugins/buttercms";
import { setCookieValue, getCookieValueByName } from "../utils/cookie";
import FormatMixin from "~/mixin/format-mixin";
import SubscribeMixin from "~/mixin/subscribe-mixin";
const CAMPAIGN_COOKIE_NAME = "callia-banner-campaign";
const HIDE_CAMPAIGN_COOKIE_NAME = "callia-hide-banner-campaign";
const COOKIE_EXPIRY_DAYS = 182;

export default {
  name: "Cal-Pop-Up-Banner",
  mixins: [FormatMixin, SubscribeMixin],
  data() {
    return {
      form: {
        email: "",
        name: "",
        phone: "",
      },
      showBanner: false,
      showIntroduction: true,
      showSignUp: false,
      showCode: false,
      pageData: {},
      isValidForm: false,
      isHomePage: false,
    };
  },
  watch: {
    "form.email"() {
      this.checkFormValid();
    },
    "form.name"() {
      this.checkFormValid();
    },
    "form.phone"() {
      this.checkFormValid();
    },
  },
  created() {
    if (
      this.$route.path == "/en-ca" ||
      this.$route.path == "/fr-ca" ||
      this.$route.path == "/"
    ) {
      this.isHomePage = true;
    }
  },
  methods: {
    hideBanner() {
      setCookieValue(HIDE_CAMPAIGN_COOKIE_NAME, true, {
        expires: COOKIE_EXPIRY_DAYS,
      });
      this.showBanner = false;
    },
    manageCampaignVisibility(currentCampaign) {
      let campaignNameCookie = getCookieValueByName(CAMPAIGN_COOKIE_NAME);
      let hideCampaignCookie = getCookieValueByName(HIDE_CAMPAIGN_COOKIE_NAME);

      if (
        currentCampaign == campaignNameCookie &&
        hideCampaignCookie == "true"
      ) {
        this.showBanner = false;
      } else if (currentCampaign != campaignNameCookie) {
        //if new campaign
        setCookieValue(CAMPAIGN_COOKIE_NAME, currentCampaign, {
          expires: COOKIE_EXPIRY_DAYS,
        });
        setCookieValue(HIDE_CAMPAIGN_COOKIE_NAME, false, {
          expires: COOKIE_EXPIRY_DAYS,
        });
        this.showBanner = true;
      } else {
        this.showBanner = true;
        setCookieValue(HIDE_CAMPAIGN_COOKIE_NAME, false, {
          expires: COOKIE_EXPIRY_DAYS,
        });
        setCookieValue(CAMPAIGN_COOKIE_NAME, currentCampaign, {
          expires: COOKIE_EXPIRY_DAYS,
        });
      }
    },
    handleAcceptEvent() {
      this.showIntroduction = false;
      this.showSignUp = true;
      this.showCode = false;
    },
    async handleSubscribeEvent() {
      await this.submit();
      this.showIntroduction = false;
      this.showSignUp = false;
      this.showCode = true;
      setCookieValue(HIDE_CAMPAIGN_COOKIE_NAME, true, {
        expires: COOKIE_EXPIRY_DAYS,
      });
      this.$store.dispatch("lineItems/SET_DISCOUNT_CODE", this.pageData['discount-code']);

    },
    handleShopNowEvent() {
      this.$router.push(`${this.$i18n.locale}/collection`);
    },
    checkFormValid() {
      this.isValidForm =
        this.isEmailValid(this.form.email) &&
        this.isValidFormName(this.form.name) &&
        this.isPhoneNumberValid(this.form.phone);
    },
    async submit() {
      try {
        await this.subscribe(
          this.$axios,
          this.form.name,
          this.form.email,
          this.$i18n.locale.split("-"),
          this.form.phone
        );
      } catch (error) {
        console.error(error);
      }
    },
  },
  async fetch() {
    try {
      const response = await butter(this.$config).page.retrieve(
        "*",
        "banner-promo",
        {
          locale: this.$i18n.locale,
          timeout: 10000,
        }
      );
      this.pageData = response?.data.data.fields;
      let campaignName = this.pageData["campaign-name"].replace(/ /g, "_");
      if (this.pageData["show-campaign"] == "false") {
        this.showBanner = false;
      } else {
        this.manageCampaignVisibility(campaignName);
      }
    } catch (error) {
      console.error(error);
    }
  },
};
